export class CalcNew {

    constructor() {

        this.formOne = document.forms.formOne;
        if (!this.formOne) {
          return;
        }
        this.fieldsets = formOne.querySelectorAll('fieldset');


        if(window.location.hash){
          this.formOne.publishingType.value = window.location.hash.substring(1);
          this.formOne.publishingType.closest('.form_relative ').classList.add('is-active');
            
            this.fieldsets.forEach(fieldset => {
              fieldset.disabled = 1;
            });

            this.formOne.querySelector(`fieldset[name="${window.location.hash.substring(1)}"]`).disabled = 0;
        }


        this.formOne.addEventListener('change', e => {
          if (e.target.name == 'publishingType') {
            this.fieldsets.forEach(fieldset => {
                fieldset.disabled = 1;
            });
            window.location.hash = e.target.value;
            this.formOne.querySelector(`fieldset[name="${e.target.value}"]`).disabled = 0;
          }
        });

        this.formOne.querySelectorAll('.order_table_row').forEach(tableRow => {
          tableRow.addEventListener('input', (e) => {
            if (e.target.type === 'number' ) {
              this._rowCalculate(tableRow);
              this._allCalculate(tableRow);
            };
          });
          tableRow.addEventListener('click', (e) => {

            if (e.target.type === 'number' ) {
              this._rowCalculate(tableRow);
              this._allCalculate(tableRow);
              return;
            };

            if (tableRow.querySelector('input[data-discount]')) {


              let ratio = +tableRow.querySelector('input[data-discount]').dataset.discount;

              if ( tableRow.querySelector('input[data-discount]').checked === false){
                ratio = ratio /100;                
              }else {
                ratio = 100 / ratio;
              }

              const fieldset = tableRow.closest('fieldset');
              let parent;
              if (fieldset) {
                parent = fieldset;
              } else {
                parent = this.formOne;
              }

              parent.querySelectorAll('.zone_price').forEach(price => {
                price.innerHTML = Math.round(price.innerHTML*ratio);

                if (!price.closest('.order_table_row').classList.contains('order_disabled')) {
                  this._rowCalculate(price.closest('.order_table_row'));
                }
              })


            }

            if (tableRow.querySelector('.readonly')) {
              return;
            }

            const dataAttr = tableRow.dataset.attr;

            if (dataAttr) {    
              const fieldset = tableRow.closest('fieldset');
              let parent;
              if (fieldset) {
                parent = fieldset;
              } else {
                parent = this.formOne;
              }

              
              parent.querySelectorAll('.order_table_row').forEach(tableRowIn => {
                
                const dataAttr2 = tableRowIn.dataset.attr;
                
                if (dataAttr === dataAttr2) {

                  tableRowIn.classList.add('order_disabled');
                  tableRowIn.querySelector('input[type=radio]').checked = false;
                  tableRowIn.querySelector('input[type=number]').setAttribute("disabled", "");
                  tableRowIn.querySelector('.zone_total').innerHTML= 0;


                }
                this._rowCalculate(tableRow);
              });

              tableRow.classList.remove('order_disabled');
              tableRow.querySelector('input[type=radio]').checked = true;
              tableRow.querySelector('input[type=number]').removeAttribute('disabled');
            }


            if (tableRow.querySelector('input[type=checkbox]')) {

              if (tableRow.classList.contains('order_disabled')) {
                tableRow.classList.remove('order_disabled');
                tableRow.querySelector('input[type=checkbox]').checked = true;
                if (!tableRow.querySelector('input[data-discount]')) {

                  tableRow.querySelector('input[type=number]').removeAttribute('disabled');
                  this._rowCalculate(tableRow);
                }
              } else {
                tableRow.classList.add('order_disabled');
                tableRow.querySelector('input[type=checkbox]').checked = false;
                if (!tableRow.querySelector('input[data-discount]')) {
                  tableRow.querySelector('input[type=number]').setAttribute('disabled', '');
                  tableRow.querySelector('.zone_total').innerHTML = 0;
                }

              }

            }

    
            if (tableRow.querySelector('input[data-electricity')){

              const fieldset = tableRow.closest('fieldset');
              let parent;
              if (fieldset) {
                parent = fieldset;
              } else {
                parent = this.formOne;
              }

              parent.querySelector('input[name=electricity]').closest('.order_table_row').querySelector('.zone_price').innerHTML = tableRow.querySelector('input[data-electricity]').dataset.electricity;
              parent.querySelector('input[name=electricity]').value = tableRow.querySelector('input[data-electricity]').dataset.electricity;
              this._rowCalculate(parent.querySelector('input[name=electricity]').closest('.order_table_row'));
      
            }        
            
            this._allCalculate(tableRow);

          });
          
        });
        

        
    }
  
  _allCalculate(tableRow) {
    const fieldset = tableRow.closest('fieldset');
    let parent;
    if (fieldset) {
      parent = fieldset;
    } else {
      parent = this.formOne;
    }

    let sum = 0;

    parent.querySelectorAll('.order_table_row').forEach(el => {
      // console.log(el.querySelector('.zone_total'));
      if (el.querySelector('.zone_total')) {
        sum+= +el.querySelector('.zone_total').innerHTML;
      }
    })
    parent.querySelector('.final_zone_total').innerHTML = sum;
    parent.querySelector('input[name=final_zone_total]').value = sum;
  }
 
  _rowCalculate(tableRow) {
    let count = 1;
    if (tableRow.querySelector('input[type=number]')) {
      count = +tableRow.querySelector('input[type=number]').value;
    }
    const price = +tableRow.querySelector('.zone_price').innerHTML;
    tableRow.querySelector('.zone_total').innerHTML= count*price;

  }
  

}

const calcNew = new CalcNew();